






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as uiUtil from "@/uiUtil";
import { ValidationRule } from "@/util";

@Component
export default class MoneyField2 extends Vue {
  hasError = false;
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: -1 }) initialValue!: number;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) cssClass!: string;
  @Prop({ default: false }) cents!: boolean;
  @Prop({ default: false }) filled!: boolean;
  @Prop({ default: false }) solo!: boolean;
  @Prop({ default: false }) flat!: boolean;
  @Prop({ default: false }) hideDetails!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: () => [] }) rules!: ValidationRule[];

  innerValue = 0;

  created() {
    this.onValue(this.initialValue);
  }

  toValue(val: number): number {
    if (this.cents) {
      return Math.round(val * 100);
    }
    return val;
  }

  toMoney(val: number): number {
    if (this.cents) {
      return val / 100;
    }
    return val;
  }

  @Watch("innerValue")
  changeValue(newValue: number) {
    const extVal = this.toValue(newValue);
    if (this.value !== extVal) {
      this.$emit("input", extVal);
    }
  }

  @Watch("value")
  onValue(newValue: number) {
    const moneyVal = this.toMoney(newValue);
    if (this.innerValue !== moneyVal) {
      this.innerValue = moneyVal;
    }
  }

  get localRules() {
    return uiUtil.rulesRunner(this);
  }
}
